//? Library
import React, { useEffect, useState, useCallback } from 'react';
import { Container, Row, Col, Form, Button, Card, Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import SummaryMoney from './SummaryMoney';
import SummarySection from './SummarySection';
import SummaryOrder from './SummaryOrder';
import SummaryStock from './SummaryStock';
import { useLazyQuery } from '@apollo/client';
import _ from 'lodash';
import { MdDateRange } from "react-icons/md";

//? Function
import { COLOR_APP, K_LOCAL_STORAGE_PAGE_HISTORY, K_LOCAL_STORAGE_SHOP_DATA } from '../../constants';
import CurrentDateModal from '../../components/currentComponent/CurrentDateModal';
import { GET_PAGE_HISTORY } from '../../graphql/totalSummary/query';
import { convertCurrentDate } from "../../helpers";
import SelectMultiples from './SelectMultiples';
import SelectMultipleSystem from './SelectMultipleSystem';
import 'bootstrap/dist/css/bootstrap.min.css';

const TotalSummary = () => {
    const [systemsData, setSystemsData] = useState([]);
    const [pageHistoryData, setPageHistoryData] = useState(null);
    const [pages, setPages] = useState({ amount: 0, listName: '', listId: '' });
    const [systems, setSystems] = useState({ amount: 0, listName: '' });
    const [isCurrentModals, setIsCurrentModals] = useState(false);
    const [isLoading, setIsLoading] = useState({
        loadingSummaryMoney: false,
        loadingSummaryOrder: false,
        loadingSummaryStock: false
    });
    const [disabled, setDisabled] = useState(false);
    const [cdFilter, setCdFilter] = useState({
        createdAt_gte: "",
        createdAt_lt: "",
    });
    const [activeButton, setActiveButton] = useState("today");
    
    const colorDefault = { background: COLOR_APP, color: '#fff' };

    const [getPageHistory, { loading: loadingPageHistory }] = useLazyQuery(
        GET_PAGE_HISTORY, 
        { fetchPolicy: "cache-and-network" }
    );

    // Improved fetchSystems with proper memoization
    const fetchSystems = useCallback(() => {
        try {
            const localShopData = localStorage.getItem(K_LOCAL_STORAGE_SHOP_DATA);
            if (localShopData) {
                const localData = JSON.parse(localShopData);
                const systems = localData?.systems || [];
                setSystemsData(systems);
            }
        } catch (error) {
            console.error("Error fetching systems:", error);
        }
    }, []); // Empty dependency array since it doesn't depend on any props or state

    // Improved fetchRemotePageHistory with proper memoization
    const fetchRemotePageHistory = useCallback(async () => {
        if (loadingPageHistory) return;
        
        try {
            if (loadingPageHistory) return;
            const newPageHistory = await getPageHistory({
                variables: {
                    where: {
                        save: true
                    }
                }
            });
            const newPageHistoryData = newPageHistory?.data?.getPageHistory;
            // save to local storage
            const expired = new Date();
            expired.setMinutes(expired.getMinutes() + 10);
            localStorage.setItem(K_LOCAL_STORAGE_PAGE_HISTORY, JSON.stringify({ expired, data: newPageHistoryData }));
            setPageHistoryData(JSON.parse(newPageHistoryData));
        } catch (error) {
            console.error("Error fetching remote page history:", error);
        }
    }, [getPageHistory, loadingPageHistory]);

    // Improved fetchPageHistory with proper memoization
    const fetchPageHistory = useCallback(async () => {
        try {
            const localPageHistory = localStorage.getItem(K_LOCAL_STORAGE_PAGE_HISTORY);
            
            if (localPageHistory) {
                const localData = JSON.parse(localPageHistory);
                const expired = new Date(localData?.expired);
                const now = new Date();
                
                if (localData?.data && expired > now) {
                    // console.log("local");
                    const newPageHistory = JSON.parse(localData?.data);
                    setPageHistoryData(newPageHistory);
                } else {
                    // console.log("api");
                    await fetchRemotePageHistory();
                }
            } else {
                await fetchRemotePageHistory();
            }
        } catch (error) {
            console.error("Error fetching page history:", error);
        }
    }, [fetchRemotePageHistory, setPageHistoryData]);

    const handleLoading = useCallback(() => {
        if(isLoading.loadingSummaryMoney || isLoading.loadingSummaryOrder || isLoading.loadingSummaryStock){
            setDisabled(true);
        } else {
            setDisabled(false);
        }
    }, [isLoading, setDisabled]);

    // Move useEffect after all function definitions
    useEffect(() => {
        fetchSystems();
        fetchPageHistory();
        handleLoading();
    }, [fetchSystems, fetchPageHistory, handleLoading]);

    // console.log("loading: ",isLoading.loadingSummaryMoney ,isLoading.loadingSummaryOrder ,isLoading.loadingSummaryStock, "disabled: ", disabled);

    if (loadingPageHistory) return <p>Loading Filter...</p>

    return (
        <>
            <Container fluid>
                <h3 style={{ fontWeight: "bold", width: 200 }}>ສະຫລຸບຍອດ</h3>
                <Row className="mb-4 p-3 bg-light">
                    <Col md={2}>
                        <Form.Group>
                            <Form.Label>ເລືອກລະບົບ:  </Form.Label>
                            { !_.isEmpty(systemsData) && <SelectMultipleSystem setOption={setSystems} options={systemsData} isLoading={isLoading}/>}
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Group>
                            {/* <Form.Label>ເພສ: {pages?.pageList} </Form.Label> */}
                            <Form.Label>ເພສ:  </Form.Label>
                            { !_.isEmpty(pageHistoryData) && <SelectMultiples setOption={setPages} options={pageHistoryData} isLoading={isLoading}/>}
                        </Form.Group>
                    </Col>

                    <Col md={5}>
                        <div className="box-filter">
                            <label>ວັນທີ,ເດືອນ,ປີ</label>

                            <Button
                                disabled={disabled}
                                variant="outline-secondary"
                                onClick={() => setIsCurrentModals(true)}
                                style={{ width: "100%", display: 'flex', gap: 5, justifyContent: 'space-between', alignItems: 'center' }}
                            >
                                <MdDateRange style={{ fontSize: 25 }} />
                                {cdFilter?.createdAt_gte === "" && cdFilter?.createdAt_lt === "" ? (
                                    "mm/dd/yyyy"
                                ) : (
                                    <>
                                    {convertCurrentDate(cdFilter?.createdAt_gte) + "-" + convertCurrentDate(cdFilter?.createdAt_lt)}
                                    </>
                                )}
                            </Button>
                        </div>
                    </Col>
                    {/* modal current date  */}
                    <CurrentDateModal
                        onCloseModal={() => setIsCurrentModals(false)}
                        openModal={isCurrentModals}
                        setCdFillter={setCdFilter}
                        setActiveButton={setActiveButton}
                        activeButton={activeButton}
                        backdrop={true}
                    />
                </Row>

            {/* Summary Section */}
                <Card className="mb-4">
                    <Card.Header style={colorDefault}>
                    <h5>ລາຍລະອຽດ</h5>
                    </Card.Header>
                    <Card.Body>
                        { (systems?.amount > 0 || pages?.amount > 0 || !_.isEmpty(cdFilter?.createdAt_gte))
                        && <SummarySection systems={systems} pages={pages} date={cdFilter}/>}
                    </Card.Body>
                </Card>

            {/* Statistics Money */}
                <Card className="mb-4">
                    <Card.Header style={colorDefault}>
                        <h5>ຍອດເງີນ</h5>
                    </Card.Header>
                    <Card.Body>
                    {(systems.amount > 0 || pages.amount > 0) && (
                            <SummaryMoney systems={systems} pages={pages} date={cdFilter} setIsLoading={setIsLoading}/>
                        )}
                    </Card.Body>
                </Card>
            {/* Statistics Order */}
                <Card className="mb-4">
                    <Card.Header style={colorDefault}>
                        <h5>ຍອດອໍເດີ</h5>
                    </Card.Header>
                    <Card.Body>
                        {(systems.amount > 0 || pages.amount > 0) && (
                            <SummaryOrder systems={systems} pages={pages} date={cdFilter} setIsLoading={setIsLoading} />
                        )}
                    </Card.Body>
                </Card>
                
            {/* Detailed Statistics */}
                <Card className="mb-4">
                    <Card.Header style={colorDefault}>
                        <h5>ຍອດສີນຄ້າ</h5>
                    </Card.Header>
                    <Card.Body>
                        {(systems.amount > 0 || pages.amount > 0) && (
                            <SummaryStock systems={systems} pages={pages} date={cdFilter} setIsLoading={setIsLoading}/>
                        )}
                    </Card.Body>
                </Card>
                
            </Container>
        </>
    );
};

export default TotalSummary;